import h from 'hyperscript';

import saveIcon from '@disy/cadenza-icons/save.svg';
import { icon } from '@disy/lib/icon';

import { Modal } from 'ui/dialog/modal/modal';

import type { ObjecttypePublishingNetworkDto } from 'cadenza/api-client/dto/objecttype-publishing-network-dto';
import { openWorkbookTestSuite } from 'cadenza/workbook/header/save-workbook-actions/open-workbook-test-suite-function';

import i18n from './publish-objecttype-actions.properties';
import './publish-objecttype-validation-dialog.css';

const COMPONENT_NAME = 'd-publish-objecttype-validation-dialog';

export class PublishObjecttypeValidationDialog extends Modal {
  _loadingMessageDialog;
  _publish;

  constructor({
    loadingMessageDialog,
    numberOfErrors,
    numberOfWarnings,
    objecttypePublishingNetworkDto,
    testSuiteResultId,
    publish,
  }: {
    loadingMessageDialog: Modal;
    numberOfErrors: number;
    numberOfWarnings: number;
    objecttypePublishingNetworkDto: ObjecttypePublishingNetworkDto;
    testSuiteResultId: string;
    publish: () => Promise<void>;
  }) {
    const errorsText = numberOfErrors === 1 ? 'singular' : 'plural';
    const warningsText = numberOfWarnings === 1 ? 'singular' : 'plural';
    const errorsAndWarningsText = `testing.errorsAndWarnings.description.${errorsText}.${warningsText}`;

    super({
      cancelButton: i18n('testing.cancel.title'),
      submitButton: i18n('testing.export.title'),
      title: 'WARNING',
      titleIcon: icon(saveIcon),
      content: () =>
        Promise.resolve(
          h('.d-stack-v.space-4', [
            h('div', [
              h('h1', i18n(errorsAndWarningsText, { errors: numberOfErrors, warnings: numberOfWarnings })),
              h('p', i18n('testing.warningMessage')),
              h('p', i18n('testing.showResults.description')),
              h('button.button', i18n('testing.showResults.title'), {
                onclick: (event: Event) => {
                  event.preventDefault();
                  // publishing the objecttype, running the testsuite on the last versions of all relevant workbooks
                  openWorkbookTestSuite(
                    objecttypePublishingNetworkDto.workbooksInNetwork[0].workbookId,
                    // objecttypePublishingNetworkDto.repositoryName,
                    // objecttypePublishingNetworkDto.printableObjecttypeDto.objecttypeId, // there is at least one workbook, otherwise there wouldn't be errors/warnings
                    { testSuiteResultId, mode: 'SHOW_WORKBOOK_NETWORK' },
                  );
                },
              }),
            ]),
            // h('.d-alert.d-alert-success', h('strong', i18n('publish-objecttype.success.infoMessageAfterTesting'))),
          ]),
        ),
    });

    this.classList.add(COMPONENT_NAME);

    this._loadingMessageDialog = loadingMessageDialog;
    this._publish = publish;

    this.addEventListener('cancel', () => loadingMessageDialog.closeAll());
  }

  protected override async onSubmit(event: SubmitEvent) {
    super.onSubmit(event);
    await this.setLoading(this._publish());
    this.closeAll();
    this._loadingMessageDialog.closeAll();
  }
}

customElements.define(COMPONENT_NAME, PublishObjecttypeValidationDialog);
